export default "__VITE_ASSET__8fe4a173__"